import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import { showModal } from '@/components/Modal';
import classNames from 'classnames';
import { SystemStateEnum } from '@/utils/constant';
const fetchApi = new CollectMapApi();
const ExitCollectMap = (props: {
  vehicleName: string;
  cockpitNumber: string;
  taskId: number;
  systemState: any;
  onClose: any;
}) => {
  const { login } = useSelector((state: RootState) => state);
  const { cockpitNumber, vehicleName, onClose, taskId } = props;
  const exitCollectMap = async () => {
    try {
      if (!login.userInfo?.userName || !cockpitNumber || !vehicleName) {
        return;
      }
      fetchApi
        .switchCollection({
          cockpitNumber,
          vehicleName,
          taskId,
          action: 0,
        })
        .then(async () => {
          const res = await fetchApi.switchMode({
            cockpitNumber,
            vehicleName,
            operateTime: new Date().getTime(),
            action: 0,
          });
          if (res.code === HttpStatusCode.Success) {
            message.success(
              `${vehicleName}车辆模式将切换为普通模式，预计等待180秒`
            );
            onClose && onClose();
          } else {
            message.error(res.message || '网络请求错误');
            return;
          }
        });
    } catch (e) {
      message.error(`${vehicleName}关闭采图模式失败`);
      return;
    }
  };
  return (
    <>
      <li
        className={classNames('btn-item', {
          'exit-collect-map': props.systemState !== SystemStateEnum.OFFLINE,
          'exit-collect-map-disabled':
            !props.systemState || props.systemState === SystemStateEnum.OFFLINE,
        })}
        onClick={() => {
          if (
            !props.systemState ||
            props.systemState === SystemStateEnum.OFFLINE
          ) {
            return;
          }
          showModal({
            title: '关闭采图模式',
            content:
              '切换模式后车辆无法在无图环境跑行，请确认车辆车辆所处位置是否有地图',
            footer: {
              showCancel: true,
              showOk: true,
              cancelFunc: (cb) => cb(),
              cancelText: '关闭',
              okText: '确认',
              okFunc: (cb) => {
                exitCollectMap();
                cb();
              },
            },
          });
        }}
      >
        <i>关闭采图模式</i>
      </li>
    </>
  );
};

export default React.memo(ExitCollectMap);
